function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { mapState } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
import XLSX from 'xlsx';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import SegmentTablesComponent from '@/apps/audiences/components/SegmentTablesComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
export default {
  name: 'ProductizeUseCaseCreate',
  components: {
    SegmentTablesComponent: SegmentTablesComponent,
    PaginationVue: PaginationVue
  },
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    mode: {
      type: String,
      default: 'create'
    },
    initialData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [useCaseListMixin],
  data: function data() {
    var _this = this;
    return {
      e1: 1,
      search_table: '',
      hasFile: false,
      list_orgs: [],
      valid: false,
      flag_alert: false,
      edit: true,
      type_export_items: null,
      IDSInfo: {},
      segments: [],
      processDates: [],
      isValidated: false,
      warningMessage: '',
      keyPrevisualize: 1,
      File: [],
      fileBase64: null,
      hasTables: false,
      headers: [{
        text: 'Tablas de Sandbox',
        value: 'table_sandbox'
      }, {
        text: 'Tipo de tabla',
        value: 'type_table'
      }, {
        text: 'Tablas de inca',
        value: 'table_replace'
      }],
      // Datatable items
      tableItems: [],
      form: {
        type_export: {},
        selected_use_case: {},
        segment: null,
        description: null,
        sql_file: null,
        unique_load: false,
        buttonSelected: '1_DAY',
        number_day: null,
        weekDays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        week_day: null,
        number: '',
        numberRules: [function (v) {
          return !v || v >= 1 && v <= 28 || 'Por favor ingresa un número entre 1 y 28';
        }, function (v) {
          return !isNaN(parseFloat(v)) || 'Debe ser un número';
        }],
        end_execution_date: null
      },
      viewsData: [],
      segmentIsValid: true,
      keySearchTable: 1,
      rules: {
        segment: function segment(value) {
          return !!value || 'Este campo es requerido.';
        },
        description: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        selected_use_case: [function (value) {
          return !!value || _this.translate('reglas.field');
        }],
        type_export: [function (value) {
          return !!value || _this.translate('reglas.field');
        }],
        file: [function (v) {
          return !!v || _this.translate('customer_insights.rules.file');
        }, function (v) {
          return !v || v.size < 2000000 || _this.translate('customer_insights.rules.file_size');
        }]
      },
      menu_end_date: false
    };
  },
  mounted: function mounted() {
    this.fetchCatalogs();
    // const params = {
    //   user: this.userEmail
    // }
    // this.getOwnerUseCasesByStatus('3', params)
    var params = {
      user: this.userEmail,
      full: '1',
      status_id: '3'
    };
    this.getUseCases(this.companyCode, {
      params: params
    });

    // const params = {
    //   user: this.userEmail
    // }
    // this.getUseCasesByStatus(this.companyCode, '3', params)
    //
    this.getListOrgsDetailed();
    if (this.isEditing) {
      this.prefillFromInitialData();
    }
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({
    isEditing: function isEditing() {
      return this.mode === 'edit';
    }
  }, mapState('data-platform', ['companyCode'])), {}, {
    hasIDSInfo: function hasIDSInfo() {
      return Object.keys(this.IDSInfo).length > 0;
    },
    weekDaysList: function weekDaysList() {
      return this.form.weekDays.map(function (day, index) {
        return {
          text: day,
          value: index
        };
      });
    },
    segmentValidation: function segmentValidation() {
      var _this2 = this;
      return function (value) {
        if (!_this2.segmentIsValid) {
          return 'Segmento ya existe.';
        } else {
          return _this2.segmentIsValid;
        }
      };
    }
  }),
  methods: {
    prefillFromInitialData: function prefillFromInitialData() {
      // Mapea lo necesario del item a tu form
      var i = this.initialData || {};
      console.log('Prefill form with initial data:', i);
      // Nota: type_export_items se carga luego; si aún no están, no pasa nada
      this.form.segment = i.segmento || i.segment || null;
      this.form.description = i.export_detail || null;

      // Si conoces {id, export_type_name} del item:
      if (i.type_export_id) {
        this.form.type_export = {
          id: String(i.type_export_id),
          export_type_name: i.tipo_exportacion
        };
      }
      // selected_use_case requiere id y company_code (lo tomas del item):
      if (i.project_id) {
        this.form.selected_use_case = {
          id: i.project_id,
          company_code: i.company_code_usr || this.companyCode,
          business_name: i.caso_de_uso || ''
        };
      }

      // Config de ejecución: rellena para que validaciones pasen
      this.form.unique_load = i.carga_unica === '1' || i.carga_unica === 1 || i.carga_unica === true;
      this.form.buttonSelected = i.frecuencia || '1_DAY';
      this.form.week_day = i.dia === undefined || i.dia === null ? null : i.dia;
      this.form.number_day = i.dia === undefined || i.dia === null ? null : i.dia;
      this.form.end_execution_date = i.end_execution_date || null;

      // Importante: no hay archivo aún (obliga a subir uno nuevo)
      this.form.sql_file = null;
      this.fileBase64 = null;
      this.hasFile = false;
    },
    changeCheck: function changeCheck(item) {
      if (item.flag_copy) {
        item.flag_access = false;
        item.status_aprov = null;
        item.table_replace = null;
        item.view_id_replace = null;
        item.table_Inca = null;
        this.verificarAlerta();
      }
    },
    onSearchInput: function onSearchInput(value) {
      //console.log(value)
      this.search_table = value;
    },
    highlightText: function highlightText(text) {
      if (!this.search_table) return text;
      //console.log(text, this.search_table )
      var searchRegex = new RegExp(this.search_table, 'gi');
      return text.replace(searchRegex, function (match) {
        return "<mark class=\"pl-0 pr-0\" style=\"background-color: #e0ffe0\">".concat(match, "</mark>");
      });
    },
    verificarAlerta: function verificarAlerta() {
      var _this3 = this;
      this.flag_alert = false;
      this.tableItems.forEach(function (element) {
        if (element.status_aprov !== undefined && element.status_aprov !== null && !element.status_aprov) {
          _this3.flag_alert = true;
        }
      });
    },
    onSegmentChange: function () {
      var _onSegmentChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var value, datos, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              value = this.form.segment;
              console.log(this.form);
              if (!(!value || !this.form.selected_use_case.id || !this.form.type_export.id)) {
                _context.n = 1;
                break;
              }
              this.segmentIsValid = true;
              _context.n = 5;
              break;
            case 1:
              datos = {
                project_id: this.form.selected_use_case.id,
                segment: value,
                type_export_id: this.form.type_export.id
              };
              _context.p = 2;
              _context.n = 3;
              return UseCasesService.postTableIdAutomate(datos);
            case 3:
              response = _context.v;
              if (response && response.data) {
                this.segmentIsValid = response.data.status_export;
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('Error al validar el segmento:', _t);
            case 5:
              // Desencadenar la validación manualmente después de cambiar.
              this.$refs.segmentField.validate();
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function onSegmentChange() {
        return _onSegmentChange.apply(this, arguments);
      }
      return onSegmentChange;
    }(),
    triggerSegmentValidation: function triggerSegmentValidation() {
      console.log('triggerSegmentValidation', this.form.selected_use_case);
      this.$refs.segmentField.validate();
      this.onSegmentChange();
    },
    fetchDataAndCombine: function fetchDataAndCombine() {
      this.columns_selected = [];
      this.viewsData = [];
      var params = {
        user: this.serviceAccount,
        sandbox: this.form.selected_use_case
      };
      var dataFetched = {
        approved: [],
        revision: []
      };
      return Promise.all([MyAccessService.getObjectAccess('productivize', params).then(function (response) {
        if (response && response.data) {
          response.data.forEach(function (element) {
            var item = {
              text: element.table.id.replace(':', '.'),
              value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
              data: element,
              status: 'APPROVED'
            };
            dataFetched.approved.push(item);
          });
        }
      }), MyAccessService.getObjectAccessWithPending('productivize', params).then(function (response) {
        if (response && response.data) {
          response.data.forEach(function (element) {
            var item = {
              text: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
              value: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
              data: element,
              status: 'REVISION'
            };
            dataFetched.revision.push(item);
          });
        }
      })]).then(function () {
        return dataFetched;
      });
    },
    cleanAndPrioritizeData: function cleanAndPrioritizeData(dataFetched) {
      var _this4 = this;
      // priorizar en estado revision
      var addItemToViewsData = function addItemToViewsData(item) {
        var existingIndex = _this4.viewsData.findIndex(function (existingItem) {
          return existingItem.text === item.text;
        });
        if (existingIndex !== -1) {
          if (item.status === 'REVISION' && _this4.viewsData[existingIndex].status === 'APPROVED') {
            _this4.viewsData[existingIndex] = item;
          }
        } else {
          _this4.viewsData.push(item);
        }
      };
      dataFetched.revision.forEach(addItemToViewsData);
      dataFetched.approved.forEach(addItemToViewsData);
    },
    getObjectAccess: function getObjectAccess() {
      var _this5 = this;
      this.fetchDataAndCombine().then(function (dataFetched) {
        _this5.cleanAndPrioritizeData(dataFetched);
      });
    },
    mapearArray: function mapearArray(valor) {
      return valor.filter(function (field) {
        return field.column !== undefined && field.column !== null;
      }).map(function (field) {
        return field.column.toString();
      });
    },
    onTableSelected: function onTableSelected(item, selectedValue) {
      var _this6 = this;
      this.flag_alert = false;
      this.columns_selected = [];
      if (selectedValue.data.status === 'REVISION') {
        item.company_code_table = this.getCodeFromDomain(selectedValue.data.domain_table);
        //const columnas = this.mapearArray(selectedValue.data.fields)
        var columnas = selectedValue.data.columns_included;
        if (!this.containsAll(columnas, item.attribute_names)) {
          item.table_Inca = null;
          item.status_aprov = null;
          //tasks.toast.info('La tabla no tiene los mismos campos que el caso de uso')
          tasks.toast.info('La tabla no contiene los campos utilizados en el caso de uso. <br/> Campos utilizados en el caso de uso: ' + item.attribute_names.join(", ") + ".");
          this.keySearchTable += 1;
          this.verificarAlerta();
          return;
        }
        item.flag_access = true;
        item.status_aprov = false;
      } else {
        item.company_code_table = this.getCodeFromDomain(selectedValue.data.domain);
        if (this.viewsData.length > 0 && Object.keys(selectedValue).length > 0) {
          var params = {
            relativeResourceName: selectedValue.data.relativeResourceName,
            domain_table: selectedValue.data.domain
          };
          var consulta = {
            tables: [{
              datasetId: selectedValue.data.view.datasetId,
              domain_table: selectedValue.data.domain,
              projectId: selectedValue.data.view.projectId,
              source: "bigquery",
              tableId: selectedValue.data.view.objectId,
              is_view: true,
              always_get: true
            }]
          };
          AssignmentsService.getTablesDetails(consulta).then(function (response) {
            if (response && response.code == 200 && response.data[selectedValue.data.view.projectId + ":" + selectedValue.data.view.datasetId + "." + selectedValue.data.view.objectId]) {
              var table_detail = response.data[selectedValue.data.view.projectId + ":" + selectedValue.data.view.datasetId + "." + selectedValue.data.view.objectId];
              var _columnas = [];
              table_detail.schema.fields.forEach(function (co) {
                _columnas.push(co.name);
              });
              console.log(_columnas, item.attribute_names);
              _this6.verificarAlerta();
              if (!_this6.containsAll(_columnas, item.attribute_names)) {
                item.table_Inca = null;
                item.status_aprov = null;
                tasks.toast.info('La tabla no contiene los campos utilizados en el caso de uso. <br/> Campos utilizados en el caso de uso: ' + item.attribute_names.join(", ") + ".");
                return;
              }
              item.flag_access = false;
              item.status_aprov = true;
            }
          });
          /*AssignmentsService.getListTagEntry(params).then((response) => {
            if (response && response.code === 200) {
              const responseTPL = response.data
              const tableTags = responseTPL.objects.tags
              this.items = tableTags.filter(tag => !!tag.column)
              this.columns_selected = []
              this.partyId = null
              this.keySearchTable += 1
              this.$refs.form.resetValidation()
              const columnas = this.mapearArray(tableTags)
              this.verificarAlerta()
              if (!this.arrayContains(columnas, item.attribute_names)) {
                item.table_Inca = null
                item.status_aprov = null
                tasks.toast.info('La tabla no tiene los mismos campos que el caso de uso')
                return
              }
              item.flag_access = false
              item.status_aprov = true
            }
          })*/
        }
      }
      item.table_replace = null;
      item.view_id_replace = selectedValue.value;
      this.verificarAlerta();
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    },
    backStep: function backStep(event) {
      if (this.e1 > 1) {
        this.e1--;
        this.$emit('update-step', this.e1);
        // Puedes llamar a un método aquí según el valor de this.e1 si lo necesitas
      }
    },
    nextStep: function nextStep(event) {
      if (!this.validate()) {
        return;
      }
      if (this.e1 <= 3) {
        // Limitar a que no sea mayor que 3
        this.e1++;
        this.$emit('update-step', this.e1);
        switch (this.e1) {
          case 2:
            this.readFile();
            break;
          case 3:
            if (this.tableItems.length < 1) {
              this.e1--;
              this.$emit('update-step', this.e1);
              tasks.toast.info(this.translate('form_attrs_productize_usecase.message_no_tables'), 'Información');
            }
            break;
          case 4:
            this.SaveAndExecute();
            break;
        }
      }
    },
    dropFile: function dropFile(e) {
      this.File = e.dataTransfer.files;
      if (this.File.length > 0) {
        this.form.sql_file = e.dataTransfer.files[0];
        this.onFileSelected();
      }
    },
    ChangeUnique: function ChangeUnique() {
      console.log('ChangeUnique', this.form.unique_load);
      if (this.form.unique_load) {
        // this.buttonSelected = '0'
        this.menu_end_date = false;
        this.form.end_execution_date = null;
      }
    },
    SaveAndExecute: function SaveAndExecute() {
      var _this7 = this;
      if (!this.validate()) {
        return;
      }
      this.setShowLoading(true);
      var table = this.tableItems;
      var datos = {
        'scr_b64': this.fileBase64,
        'segment': this.form.segment,
        'company_code_usr': this.companyCode,
        'type_export_id': this.form.type_export.id,
        'export_detail': this.form.description,
        'owner_name': window.userInfo.email,
        'is_unique_load': this.form.unique_load ? '1' : '0',
        'frequency': this.form.buttonSelected,
        'update_date_number': this.form.buttonSelected === '1_WEEK' ? this.form.week_day : this.form.buttonSelected === '1_MONTH' ? this.form.number_day : null,
        'end_execution_date': this.form.end_execution_date,
        'table_detail': table
      };
      UseCasesService.postSaveProductize(datos, this.form.selected_use_case.id).then(function (response) {
        if (response && response.data && response.success) {
          //this.$refs[this.DIALOG_ADD].onClose()
          _this7.$emit('on-close', true);
          tasks.toast.success('Se ha registrado la exportación correctamente, revise el detalle.');
        } else {
          _this7.$emit('on-close', false);
          tasks.toast.success('Hubo un error un la exportación revise el detalle.');
        }
      }).finally(function () {
        _this7.setShowLoading(false);
        //this.$refs[this.DIALOG_ADD].onClose()
      });
    },
    onFileSelected: function onFileSelected() {
      var _this8 = this;
      if (!this.form.sql_file) {
        this.hasFile = false;
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        _this8.fileBase64 = event.target.result.split(',')[1]; // Get base64 string, remove "data:...;base64,"
        _this8.hasFile = true;
      };
      reader.readAsDataURL(this.form.sql_file);
    },
    fetchCatalogs: function () {
      var _fetchCatalogs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this9 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                UseCasesService.getExportTypes().then(function (response) {
                  if (response.success) {
                    var exportTypes = response.data.export_type_catalog_id;
                    exportTypes = {
                      '1': exportTypes['1'],
                      '2': exportTypes['2'],
                      '3': exportTypes['3']
                    };
                    _this9.type_export_items = Object.keys(exportTypes).map(function (key) {
                      return {
                        id: key,
                        export_type_name: exportTypes[key].name
                      };
                    });
                  }
                });
              } catch (error) {
                console.error(error);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function fetchCatalogs() {
        return _fetchCatalogs.apply(this, arguments);
      }
      return fetchCatalogs;
    }(),
    readFile: function readFile() {
      var _this0 = this;
      try {
        var data = {
          type_export_id: this.form.type_export.id,
          scr_b64: this.fileBase64
        };
        UseCasesService.postReadFile(data, this.form.selected_use_case.company_code, this.form.selected_use_case.id).then(function (response) {
          if (!response.data.records || response.data.records.length < 1) {
            _this0.e1--;
            _this0.$emit('update-step', _this0.e1);
            tasks.toast.info('' + response.data.observation, 'Información');
            return;
          }
          // this.tableItems = response.data.records
          _this0.tableItems = response.data.records.map(function (record) {
            return _objectSpread(_objectSpread({}, record), {}, {
              flag_copy: false,
              flag_access: false
            });
          });
          _this0.getObjectAccess();
        });
      } catch (error) {
        console.error(error);
      }
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this1 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this1.list_orgs = response.data;
        }
      });
    },
    getCodeFromDomain: function getCodeFromDomain(domain) {
      var entry = this.list_orgs.find(function (item) {
        return item.domain === domain;
      });
      return entry ? entry.code : null;
    },
    arrayContains: function arrayContains(arr1, arr2) {
      if (arr1.length < arr2.length) {
        return false;
      }
      var sortedArr1 = arr1.slice().sort();
      var sortedArr2 = arr2.slice().sort();
      for (var i = 0; i < sortedArr1.length; i++) {
        if (!sortedArr1.includes(sortedArr2[i])) {
          return false;
        }
      }
      return true;
    },
    containsAll: function containsAll(arr1, arr2) {
      return arr2.every(function (element) {
        return arr1.includes(element);
      });
    }
  }
};